export default {
  mediaStudentInfoTitle: 'Disparador',
  rhetoricalQuestion: 'Pregunta disparadora',
  mediaStudentInfo: 'Puedes repetir la imagen o vídeo que has utilizado en la imagen de presentación o agregar una nueva imagen o vídeo que actúe como punto de partida o disparador de tu recurso.',
  mediaSummaryStudentInfoTitle: 'Epígrafe de la imágen disparadora',
  mediaSummaryStudentInfo: 'Agrega unas líneas que vinculen esa imagen o vídeo con la temática de tu recurso.',
  pedagogicalObjectiveInfoTitle: 'Objetivo pedagógico',
  pedagogicalObjectiveInfo: 'Indica lo que se espera que los estudiantes logren/adquieran a través de este recurso. Ten en cuenta los objetivos que planteaste en la “pestaña del docente” pero redáctalos teniendo en cuenta que son los estudiantes quiénes los leerán aquí.'
}

export const en = {
  mediaStudentInfoTitle: 'Trigger',
  rhetoricalQuestion: 'Triggering question',
  mediaStudentInfo: 'You can repeat the image or video you have used in the presentation image or add a new image or video to act as a starting point or trigger for your resource.',
  mediaSummaryStudentInfoTitle: 'Trigger image caption',
  mediaSummaryStudentInfo: 'Add a few lines linking that image or video to the theme of your resource.',
  pedagogicalObjectiveInfoTitle: 'Educational goal',
  pedagogicalObjectiveInfo: 'Indicate what students are expected to achieve/acquire through this resource. Keep in mind the objectives you stated in the "teacher\'s tab" but write them keeping in mind that it is the students who will be reading them here.'
}

export const ca = {
  mediaStudentInfoTitle: 'Disparador',
  rhetoricalQuestion: 'Pregunta disparadora',
  mediaStudentInfo: 'Pots repetir la imatge o vídeo que has utilitzat a la imatge de presentació o afegir una nova imatge o vídeo que actuï com a punt de partida o disparador del teu recurs.',
  mediaSummaryStudentInfoTitle: 'Epígraf de la imatge disparadora',
  mediaSummaryStudentInfo: 'Afegeix unes línies que vinculin aquesta imatge o vídeo amb la temàtica del teu recurs.',
  pedagogicalObjectiveInfoTitle: 'Objectiu pedagògic',
  pedagogicalObjectiveInfo: 'Indica el que s\'espera que els estudiants aconsegueixin/adquireixin a través d\'aquest recurs. Tingues en compte els objectius que vas plantejar en la “pestanya del docent” però redacta\'ls tenint en compte que són els estudiants qui els llegiran aquí.'
}
